import React from "react";

const LocationPin = () => (
    <div className="pin">
        <img src={`${process.env.PUBLIC_URL}/images/Location.svg`} alt="Location icon"></img>
    </div>
)

export default LocationPin;